export const InteractiveAnswers = {
    "客观题正确率":"客观题正确率",
    "试题数":"试题数",
    "参与人数":"参与人数",
    "已批阅":"Corrected",
    "展示互动答题":"展示互动答题",
    "开始批阅":"开始批阅",
    "继续批阅":"继续批阅",
    "批阅完成":"批阅完成",
    "总题数":"Total number of questions",
    "平均分":"Average",
    "平均答题正确率":"Average accuracy rate",
    "平均得分率":"Average score rate",
    "数值评价题平均分":"Average score of evaluation",
    "已答":"Answered",
    "未答":"Unanswered",
    "已批":"Corrected",
    "未批":"Uncorrected",
    "未参与":"Not participated",
    "批阅状态":"Approval status:",
    "来源":"source: ",
    "互动答题标题":"Interactive Question Title",
    "互动答题详情":"Interactive answer details",
    "截止时间和发布时间冲突":"Deadline and publishing time conflict!",
    "已提交老师还未批改":"Submitted but not corrected by the teacher!",
    "等待老师批改点击下方查看试题可以查看作答情况":"Wait for the teacher to correct, click View Test below to check the answers",
    "您的得分":"Your score: ",
    "点击下方“查看作答”可以查看作答情况":"Click 'Check Answer' below to check the answer",
    "点击下方的“继续答题”可以继续作答试题":"Click 'Continue To Answer' below to continue to answer the question",
    "测试已结束":"Test ended!",
    "点击下方的查看试题可以查看作答情况":"Click 'View Test Question' below to check the answers",
    "未参与测试已结束":"Not participating! Test ended!",
    "点击下方的“查看试题”进行查看":"Click 'View Test Question' below to view",
    "查看作答":"Check Answer",
    "查看试题":"View test questions",
    "继续答题":"Continue To Answer",
    "打分成功":"Grade successfully",
    "进入听讲模式":"Listening mode",
}